import React, { useState, useEffect } from 'react';

export const OfflineBanner: React.FC = () => {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);
  const [wasOffline, setWasOffline] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setIsOffline(false);
      if (wasOffline) {
        // Show "back online" message briefly
        setTimeout(() => setWasOffline(false), 3000);
      }
    };

    const handleOffline = () => {
      setIsOffline(true);
      setWasOffline(true);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, [wasOffline]);

  if (isOffline) {
    return (
      <div className="fixed top-0 left-0 right-0 z-[100] bg-red-500 text-white text-center py-2 px-4 shadow-md">
        <div className="flex items-center justify-center gap-2">
          <span className="text-lg">📡</span>
          <span className="font-medium">You are offline. Some features may not be available.</span>
        </div>
      </div>
    );
  }

  if (wasOffline && !isOffline) {
    return (
      <div className="fixed top-0 left-0 right-0 z-[100] bg-green-500 text-white text-center py-2 px-4 shadow-md animate-pulse">
        <div className="flex items-center justify-center gap-2">
          <span className="text-lg">✅</span>
          <span className="font-medium">Back online!</span>
        </div>
      </div>
    );
  }

  return null;
};

export default OfflineBanner;
